import type { IIndicatorFieldsFragment } from "components/financials/modern/graphql/fragments/__generated__/IndicatorFieldsFragment.generated";
import IndicatorDetails from "components/financials/modern/indicators/IndicatorDetails";
import type { WithoutTypename } from "lib/types/graphql";

interface IndicatorListItemProps {
  indicator: WithoutTypename<IIndicatorFieldsFragment>;
  isSelected?: boolean;
  viewerCanSelect?: boolean;
  shouldHighlightBox?: boolean;
  onToggleSelected?: (nextSelected: boolean) => void;
}
export default function IndicatorListItem({
  isSelected = false,
  indicator,
  viewerCanSelect = true,
  shouldHighlightBox = true,
  onToggleSelected,
}: IndicatorListItemProps) {
  return (
    <IndicatorDetails
      isSelected={isSelected}
      viewerCanSelect={viewerCanSelect}
      shouldHighlightBox={shouldHighlightBox}
      indicator={indicator}
      onClick={() => {
        if (onToggleSelected) {
          onToggleSelected(!isSelected);
        }
      }}
    />
  );
}
